export enum CookEscalationResolutionsEnum {
    WRONG_ESCALATION = 'WRONG_ESCALATION',
    REVIVE_FROM_BLACKLIST = 'REVIVE_FROM_BLACKLIST'
}